import React, { useState } from "react";
import Table from "./Credits/Table";

export default function Credits({ member }) {
  const [collection, setCollection] = useState();
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <Table memberId={member.id} />
    </>
  );
}
